<template>
	<div
		v-if="service.loadedPricingData"
		:class="{ 'h-full': isCarousel }"
	>
		<!-- NDC discount bubble -->
		<div
			class="container relative"
			v-if="
				discount &&
				(service.showPurchase ||
					service.showCheckAvailability ||
					service.showHasPurchased)
			"
		>
			<div
				class="discountBgColor absolute top-0 right-0 text-s font-medium mr-2 px-2.5 py-1.0 rounded-full -top-4"
			>
				<div v-if="discount.pricingRule == 'FreeVisit'">
					<p class="green">Buy now and save with a free visit</p>
				</div>
				<div v-if="discount.pricingRule == 'FreeRound'">
					<p class="green">Buy now and save with a free round</p>
				</div>
				<div v-if="discount.pricingRule == 'FreeService'">
					<div v-if="discount.freeService">
						<p class="green">
							Buy now and get {{ discount.freeService.name }} for free
						</p>
					</div>
					<div v-if="discount.serviceRequired">
						<p class="green">
							Get this service for free when you purchase
							{{ discount.serviceRequired.name }}
						</p>
					</div>
				</div>
				<div v-if="discount.pricingRule == 'Reduce'">
					<div v-if="discount.serviceAffected">
						<p class="green">
							Buy now and save ${{ discount.reducedAmount }} on
							{{ discount.serviceAffected.name }}
						</p>
					</div>
					<div v-if="discount.serviceRequired">
						<p class="green">
							Buy {{ discount.serviceRequired.name }} and save ${{
								discount.reducedAmount
							}}
						</p>
					</div>
				</div>
				<div v-if="discount.is20Percent">
					<p class="green">Buy now and save ${{ discount.reducedAmount }}</p>
				</div>
			</div>
		</div>

		<!-- Service Card Body -->
		<div class="h-full" :class="borderClass + ' ' + affectedServiceBorder">
			<div :class="outerClass">
				<div :class="imageClass" v-if="service.ServiceImage && size != 'tiny'">
					<div v-if="isListView" :class="imageClasses" :style="{ backgroundImage: `url('${service.ServiceImage}')` }"
						style="height: 250px;background-position: center;border-radius: 25px; background-size: cover;background-repeat: no-repeat;">
					</div>
					<img v-else
						loading="lazy"
						:src="service.ServiceImage"
						:alt="service.ServiceName"
						:class="imageClasses"
					/>
				</div>

				<div :class="[isListView ? 'text-left ' : '', descriptionClass]" v-if="size != 'tiny'">
					<h2>{{ service.ServiceName }}</h2>
					<p  style="font-size: 0.85rem;"
						class="font-semibold"
						v-if="!service.isMonthly && service.remainingRounds"
					>
						{{ service.remainingRounds }} visits left in the year
					</p>
					<p v-html="service.ServiceDesc"></p>
					<div v-if="displayLearnMore">
						<NuxtLink :to="'/services/' + service.ServiceSlug + '/'"><strong>Learn more</strong></NuxtLink>
					</div>
					<p v-if="discountText && discountText.length > 0">
						<span class="icon-star"></span><strong>{{ discountText }}</strong>
					</p>
				</div>

				<div :class="[isListView ? 'p-4' : addToCartClass]" v-if="service.loadedPricingData" class="">
					<h2 v-if="size == 'tiny'">{{ service.ServiceName }}</h2>


					<div class="flex items-center justify-center"  v-if="packageServices">
						<div class="bg-red-600 text-white" style="
							clip-path: polygon(0% 50%, 15% 0, 100% 0, 100% 100%, 15% 100%);
							padding-top: 10px;
							padding-bottom: 10px;
							padding-right: 20px;
							padding-left: 35px;
							border-bottom-right-radius: 15px;
							border-top-right-radius: 15px;">

							<div class="flex items-center">
								<span class="leading-none mr-1" style="font-size: 1.2rem;font-weight: bold;">20% OFF</span>
							</div> 
						</div>
					</div>

					<!-- If there's a price, then the user can purchase the service -->
					<div v-if="service.showPurchase">
						<!-- Price Display -->
						<div class="p-2" :class="[isListView ? 'text-right' : '']">
							<span v-if="service.isAddon" class="price"
								><span class="text-base">Additional</span></span
							>

							<p v-if="service.ServiceDefId == 2" class="line-through italic">
								Was
								{{
									formatPrice(getServicePrice(cartPaymentInfo, payType) / 0.8)
								}}
							</p>
							<p class="price mb-1">
								{{ formatPrice(getServicePrice(cartPaymentInfo, payType)) }}
							</p>

							<p class="m-0">
								<span
									v-if="service.isMonthly || payType === 'autoPayInstallment'"
								>
									Per month ({{
										billingMonthsRemaining
									}}
									months)
								</span>
								<span v-else-if="payType === 'payNow'"> Per year </span>
								<span v-else> Per visit </span>
							</p>

							<div v-if="service.initialPrice">
								<h3>{{ formatPrice(service.initialPrice) }}</h3>
								<p class="m-0">Initial application fee</p>
							</div>

							<p class="font-semibold red" v-if="neighborhoodDiscountText">
								<em>{{ neighborhoodDiscountText }}</em>
							</p>
						</div>

						<!-- Add/Added To Cart -->
						<span
							v-if="(!service.isAddon || isParentServicePurchased(service))"
							:class="{ 'text-left': isListView }"
						>
							<p
								:id="`add-to-cart-button-${service.ServiceDefId}`"
								v-bind:class="{ hidden: service.addedToCart }"
							>
								<a
									href="#"
									class="button visible"
									@click.stop.prevent="addToCart(service)"
									>Add to cart</a
								>
							</p>
							<p
								:id="`added-to-cart-button-${service.ServiceDefId}`"
								v-bind:class="{ hidden: !service.addedToCart }"
							>
								<a
									href="#"
									class="button button-white button-added"
									@click.stop.prevent
									:id="`button-${service.ServiceDefId}`"
									>Added to cart</a
								>
							</p>
						</span>
					</div>

					<div v-else-if="service.showCheckAvailability">
						<p class="text-center">
							<a
								href="#"
								class="button visible"
								@click.stop.prevent="$refs.addressModal.show()"
								>Check Availability</a
							>
						</p>
					</div>

					<div v-else-if="service.showHasPurchased">
						<div class="text-center">
							<h3>You have purchased this or a related service.</h3>
							Contact us if you have any questions.
							<p class="mb-0">
								<NuxtLink to="/about-us/contact-spring-green/" class="button"
									>Contact Us</NuxtLink
								>
							</p>
						</div>
					</div>

					<div v-else-if="service.isQuoteOnly">
						<div class="text-center">
							<h3>This service pricing is provided by quote</h3>
							<p>
								Add the service to your cart, checkout, and we will contact you
								to provide your personalized price.
							</p>
							<a
								v-if="!service.addedToCart"
								href="#"
								class="button visible"
								@click.stop.prevent="addToCart(service)"
								>Request a quote</a
							>
							<a
								v-else
								href="#"
								class="button button-white button-added"
								@click.stop.prevent
								>Added to cart</a
							>
						</div>
					</div>

					<div v-else>
						<div class="text-center">
							<h3>This service may not be available in your area.</h3>
							Contact your local Spring Green office for details.
							<p class="mb-0">
								<NuxtLink to="/about-us/contact-spring-green/" class="button"
									>Contact Us</NuxtLink
								>
							</p>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Toast and Modals -->
		<Toast v-if="showToast" @hideToast="toggleToast">{{ message }}</Toast>

		<AddressModal ref="addressModal" :redirectPath="route.path"></AddressModal>

		<AddedToCartModal
			ref="addToCartModal"
			:serviceData="serviceData"
			:service="service"
		></AddedToCartModal>

		<!-- <PaymentOptionsInfoModal ref="paymentOptionsInfoModal"></PaymentOptionsInfoModal> -->
	</div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type CartPaymentInfo from "~/domains/payment/cart/CartPaymentInfo";
import type { PayType } from "~/domains/payment/PayType";
import type State from "~/domains/store/State";
import {
	 getFormattedPrice,
	getInstallmentBillingMonthsRemaining,
	getMonthlyBillingMonthsRemaining,
} from "~/utils/payment";

const { $payments, $services, $cart } = useNuxtApp();
const route = useRoute();
const store: Store<State> = useStore();

const props = defineProps({
	size: String,
	service: {
		type: Object,
		required: true,
	},
	neighborhoodDiscountText: String,
	discountText: String,
	isCarousel: Boolean,
	borderOverride: String,
	layout: String,
	packageServices: Boolean,
});

const emit = defineEmits(["onAddedToCart"]);

const showToast = ref(false);
const message = ref("There was a problem. Please try again at another time.");
const borderClass = ref("red-stroke mb-6");
const outerClass = ref("grid md:grid-cols-2 lg:grid-cols-4 bg-white rounded text-center lg:text-left");
const descriptionClass = ref("lg:col-span-2 px-8 pt-8 pb-4 text-left");
const addToCartClass = ref("px-8 md:pt-8 pb-4 border-left md:col-span-2 lg:col-span-1");
const imageClasses = ref("rounded service-image-square");
const imageClass = ref("col-4");
const displayLearnMore = ref(false);
const discount = ref(null);
const affectedServiceBorder = ref("");
const payType = ref(null);
const showCartModal = ref(false);

const addressModal = useTemplateRef("addressModal");
const addToCartModal = useTemplateRef("addToCartModal");

const serviceData = computed(() => store.state.persistedState.serviceData ?? {});

const payTypeOptions = computed(() => {
	return $payments
		.getCartAllowedPayTypes([props.service])
		.filter((payType) => {
			if ($services.isTotalHomePestControlService(props.service)) {
				return payType === "autoPay";
			} else {
				return true;
			}
		})
		.map((payType) => {
			return {
				value: payType,
				label: $payments.getPayTypeName(payType),
			};
		});
});

const cartPaymentInfo = computed(() => {
	const installmentBillingMonthsRemaining = store.state.persistedState.paymentInfo?.remainingMonths ?? getInstallmentBillingMonthsRemaining(new Date(), store.state.persistedState.order);
	const cartPaymentInfo = {
		services: [props.service],
		coupons: [],
		ndc: store.state.persistedState.ndcInfo,
		franchiseDiscounts: [],
		payType: payType.value,
		taxesInfo: [], // TODO: Taxes?
		installmentBillingMonthsRemaining: installmentBillingMonthsRemaining,
		serviceMonthsRemaining: getMonthlyBillingMonthsRemaining(new Date()),
	};

	return $cart.getCartPaymentInfo(cartPaymentInfo);
});

const billingMonthsRemaining = computed(() => {
	return props.service.isMonthly
		? getMonthlyBillingMonthsRemaining(new Date())
		: (store.state.persistedState.paymentInfo?.remainingMonths ?? getInstallmentBillingMonthsRemaining(new Date(), store.state.persistedState.order));
});

const toggleToast = () => {
	showToast.value = !showToast.value;
};

const isListView = computed(() => props.layout == 'listview' ? true : false);

const addToCart = async (service) => {
	let response = undefined;
	response = await $services.addServiceToCart(service);

	if (response.successful) {
		showCartModal.value = true;

		addToCartModal.value?.show();
		if (document.getElementById("add-to-cart-button-" + service.ServiceDefId))
			document
				.getElementById("add-to-cart-button-" + service.ServiceDefId)
				.classList.add("hidden");
		if (document.getElementById("added-to-cart-button-" + service.ServiceDefId))
			document
				.getElementById("added-to-cart-button-" + service.ServiceDefId)
				.classList.remove("hidden");
	} else if (response.message) {
		message.value = response.message;
		showToast.value = true;
	}

	response.removedServiceIds.forEach(function (removedId) {
		if (document.getElementById("add-to-cart-button-" + removedId))
			document
				.getElementById("add-to-cart-button-" + removedId)
				.classList.remove("hidden");
		if (document.getElementById("added-to-cart-button-" + removedId))
			document
				.getElementById("added-to-cart-button-" + removedId)
				.classList.add("hidden");
	});

	emit("onAddedToCart", service);
};

const isParentServicePurchased = async (service) => {
	return await $services.isParentServicePurchased(service);
};

const setDefaultPayType = () => {
	payType.value = "autoPay";
};

const getServicePrice = (cartPaymentInfo: CartPaymentInfo, payType: PayType) => {
	switch (payType) {
		case "autoPayInstallment":
			return cartPaymentInfo.dueMonthly;
		case "autoPay":
			return cartPaymentInfo.services[0]?.mainPrice;
		case "payNow":
			return cartPaymentInfo.dueToday;
		default:
			return cartPaymentInfo.services[0]?.UniversalPricing?.finalPrice;
	}
};

watch(payTypeOptions, () => {
	setDefaultPayType();
});

onMounted(() => {
	// var borderColor = ["6", "0", "1"].includes(props.service.ServiceCategory)
	// 	? "red-stroke"
	// 	: "green-stroke";
	// if (props.borderOverride) {
	// 	if (props.borderOverride.includes("red") ||
	// 		props.borderOverride.includes("Red") ||
	// 		props.borderOverride.includes("orange")
	// 	) {
	// 		borderColor = "red-stroke";
		// } else if (props.borderOverride.includes("green") ||
		// 	props.borderOverride.includes("Green")
		// ) {
		// 	borderColor = "green-stroke";
	// 	}
	// }
    let borderColor = isListView.value ? " ": "green-stroke";

	if (props.borderOverride && props?.borderOverride.includes("orange")
	) {
		borderColor  = borderColor + " orange-stroke";
	}
	
	if (props.size == "tiny") {
		borderClass.value = borderColor;
		outerClass.value = "bg-white m-5px rounded h-full text-center";
		descriptionClass.value = "p-4";
		addToCartClass.value = isListView.value ? "p-4" : "p-4 text-center";
		imageClass.value = "";
		imageClasses.value = "rounded w-full";
	} else if (props.size == "medium") {
		borderClass.value = borderColor;
		outerClass.value =
			"bg-white m-5px rounded h-full grid grid-cols-2 text-center";
		descriptionClass.value = "p-4";
		addToCartClass.value = isListView.value ? "p-4" : "p-4 text-center";
		imageClass.value = "col-span-3";
		imageClasses.value = "rounded w-full mb-4 service-image";
	} else if (props.size == "small") {
		borderClass.value = borderColor;
		outerClass.value =
			"bg-white m-5px rounded h-full text-center flex flex-col";
		descriptionClass.value = "p-4 flex-grow";
		addToCartClass.value = isListView.value ? "p-4" : "p-4 text-center";
		imageClass.value = "";
		imageClasses.value = "rounded w-full";
	} else {
		borderClass.value = borderColor + " mb-6";
		outerClass.value =
			"grid md:grid-cols-2 lg:grid-cols-4 bg-white rounded text-center";
		descriptionClass.value =
			"lg:col-span-2 px-4 pt-4 md:px-8 md:pt-8 md:pb-4 text-left";
		addToCartClass.value += " text-center";
		imageClass.value = "";
		imageClasses.value = "rounded service-image-square";
	}

	if (route.path != "/services/" + props.service.ServiceSlug) {
		displayLearnMore.value = true;
	}

	var coupon = store.state.persistedState.ndcInfo;

	if (coupon?.product?.id == props.service.ServiceDefId) {
		if (
			coupon.pricingRule == "FreeVisit" ||
			coupon.pricingRule == "FreeRound"
		) {
			discount.value = { pricingRule: coupon.pricingRule };
			affectedServiceBorder.value = "thickBorder";
		}

		if (
			coupon?.product?.extraService?.id &&
			coupon.pricingRule == "FreeService" &&
			(coupon?.product?.extraService?.showPurchase ||
				coupon?.product?.extraService?.showCheckAvailability ||
				coupon?.product?.extraService?.showHasPurchased)
		) {
			discount.value = {
				pricingRule: coupon.pricingRule,
				freeService: coupon?.product?.extraService,
			};
			affectedServiceBorder.value = "thickBorder";
		}

		if (coupon.pricingRule == "Reduce") {
			if (
				coupon?.product?.extraService &&
				(coupon?.product?.extraService?.showPurchase ||
					coupon?.product?.extraService?.showCheckAvailability ||
					coupon?.product?.extraService?.showHasPurchased)
			) {
				discount.value = {
					pricingRule: coupon.pricingRule,
					serviceAffected: coupon?.product?.extraService,
					reducedAmount:
						coupon?.product?.extraService.mainPrice *
						(100.0 / coupon.product.extraServiceDiscount),
				};
				affectedServiceBorder.value = "thickBorder";
			}
		}

		if (!coupon.pricingRule && coupon.is20Percent) {
			discount.value = {
				is20Percent: coupon.is20Percent,
				reducedAmount: props.service.remainingPrice * coupon.priceRuleValue,
			};
			affectedServiceBorder.value = "thickBorder";
		}
	}

	if (coupon?.product?.extraService?.id == props.service.ServiceDefId) {
		if (
			coupon.pricingRule == "FreeService" &&
			(coupon?.product?.extraService ?? false) &&
			coupon?.product?.extraService?.id == props.service.ServiceDefId &&
			(coupon?.product?.extraService?.showPurchase ||
				coupon?.product?.extraService?.showCheckAvailability ||
				coupon?.product?.extraService?.showHasPurchased)
		) {
			discount.value = {
				pricingRule: coupon.pricingRule,
				serviceRequired: coupon.product,
			};
			affectedServiceBorder.value = "thickBorder";
		}

		if (coupon.pricingRule == "Reduce") {
			if (
				(coupon?.product?.extraService ?? false) &&
				coupon?.product?.extraService?.id == props.service.ServiceDefId &&
				(coupon?.product?.extraService?.showPurchase ||
					coupon?.product?.extraService?.showCheckAvailability ||
					coupon?.product?.extraService?.showHasPurchased)
			) {
				discount.value = {
					pricingRule: coupon.pricingRule,
					serviceRequired: coupon.product,
					reducedAmount:
						props.service.mainPrice *
						(100.0 / coupon.product.extraServiceDiscount),
				};
				affectedServiceBorder.value = "thickBorder";
			}
		}
	}

	setDefaultPayType();
});

const formatPrice = (value: number) => {
	return getFormattedPrice(value);
};
</script>


<style scoped>
.discountBgColor {
	background: linear-gradient(180deg, #4da43a 0%, #25590b 100%);
	-webkit-text-fill-color: white;
}

.thickBorder {
	border-top-width: 6px;
	border-bottom-width: 6px;
	border-left-width: 6px;
	border-right-width: 6px;
}

.service-image-square {
	border-radius: 15px
}

.small-image {
	border-radius: 15px;
}
.orange-stroke {
	border: 2px solid #E47907;
	background: #fff;
    padding: 1rem;
    border-radius: 15px;
    box-sizing: border-box;
	margin: 0;
}
</style>
